import MetaTags from "@/components/MetaTags";
import Link from "next/link";
import Image from "next/image";

// Platform Partners
import bigcommerce from "@/public/partners/bigcommerce.jpg";
import shopify from "@/public/partners/shopify.jpg";
import miva from "@/public/partners/miva.jpg";
import woocommerce from "@/public/partners/woocommerce.jpg";
import shift4shop from "@/public/partners/shift4shop.jpg";
import wordpress from "@/public/partners/wordpress.jpg";

// Ventura Web Design Partners
import ups from "@/public/partners/ups.jpg";
import zinrelo from "@/public/partners/zinrelo.jpg";
import advancedShippingManager from "@/public/partners/advanced-shipping-manager.jpg";
import klaviyo from "@/public/partners/klaviyo.jpg";
import constantContact from "@/public/partners/constant-contact.jpg";

// Companies We Work With
import braintree from "@/public/partners/braintree.jpg";
import brightpearl from "@/public/partners/brightpearl.jpg";
import jitterbit from "@/public/partners/jitterbit.png";
import mailchimp from "@/public/partners/mailchimp.jpg";
import listrak from "@/public/partners/listrak.jpg";
import podium from "@/public/partners/podium.jpg";
import shopperApproved from "@/public/partners/shopper-approved.jpg";
import tolstoy from "@/public/partners/tolstoy.jpg";
import yotpo from "@/public/partners/yotpo.jpg";
import olark from "@/public/partners/olark.gif";
import shipstation from "@/public/partners/shipstation.gif";
import wpengine from "@/public/partners/wpengine.png";

import shippo from "@/public/partners/shippo.png";
import gorgias from "@/public/partners/gorgias.png";
import trustpilot from "@/public/partners/trustpilot.png";
import justuno from "@/public/partners/justuno.png";
import hotjar from "@/public/partners/hotjar.png";

const platformPartners = [
  {
    image: bigcommerce,
    name: "BigCommerce",
    website: "https://www.bigcommerce.com",
  },
  {
    image: shopify,
    name: "Shopify",
    website: "https://www.shopify.com",
  },
  {
    image: miva,
    name: "Miva",
    website: "https://www.miva.com",
  },
  {
    image: woocommerce,
    name: "WooCommerce",
    website: "https://woocommerce.com",
  },
  {
    image: shift4shop,
    name: "Shift4Shop",
    website: "https://www.shift4shop.com",
  },
  {
    image: wordpress,
    name: "WordPress",
    website: "https://wordpress.org",
  },
];

const venturaWebDesignPartners = [
  {
    image: ups,
    name: "UPS",
    website: "/ups/",
  },
  {
    image: zinrelo,
    name: "Zinrelo",
    website: "https://www.zinrelo.com/",
  },
  {
    image: yotpo,
    name: "Yotpo",
    website: "https://www.yotpo.com/",
  },
  {
    image: klaviyo,
    name: "Klaviyo",
    website: "https://www.klaviyo.com/partners/signup?utm_source=0013o00002cO5u7AAC&utm_medium=partner",
  },
  {
    image: constantContact,
    name: "Constant Contact",
    website: "https://www.constantcontact.com",
  },
    {
    image: mailchimp,
    name: "Mailchimp",
    website: "https://www.mailchimp.com",
  },
];

const companiesWeWorkWith = [
  {
    image: braintree,
    name: "Braintree",
    website: "https://www.braintreepayments.com",
  },
  {
    image: brightpearl,
    name: "Brightpearl",
    website: "https://www.brightpearl.com",
  },
  {
    image: jitterbit,
    name: "JitterBit",
    website: "https://www.jitterbit.com/",
  },
  {
    image: listrak,
    name: "Listrak",
    website: "https://www.listrak.com",
  },
  {
    image: advancedShippingManager,
    name: "Advanced Shipping Manager",
    website: "https://advancedshippingmanager.com/",
  },
  {
    image: shopperApproved,
    name: "Shopper Approved",
    website: "https://www.shopperapproved.com",
  },
  {
    image: tolstoy,
    name: "Tolstoy",
    website: "https://www.gotolstoy.com",
  },
  {
    image: olark,
    name: "Olark",
    website: "https://fas.st/t/XRFHTBFS",
  },
  {
    image: shipstation,
    name: "ShipStation",
    website: "https://mbsy.co/6mWvsc",
  },
  {
    image: wpengine,
    name: "WP Engine",
    website: "https://wpengine.com/more/partnerspecialoffer/?w_agcid=FHZr1UUN",
  },
  {
    image: shippo,
    name: "Shippo",
    website: "https://goshippo.com",
  },
  {
    image: gorgias,
    name: "Gorgias",
    website: "https://www.gorgias.com",
  },
  {
    image: trustpilot,
    name: "Trustpilot",
    website: "https://www.trustpilot.com",
  },
  {
    image: justuno,
    name: "Justuno",
    website: "https://www.justuno.com",
  },
  {
    image: hotjar,
    name: "Hotjar",
    website: "https://www.hotjar.com",
  },
];


export default function Partners() {
  return (
    <>
      <MetaTags
        pageTitle="Our Partners"
        pageDescription="We partner with the best eCommerce platforms, web design companies, and software providers to help you grow your business."
        path="/partners"
      />
      <div>
        <div className="mx-auto max-w-screen-xl px-5 py-20">
          <div className="flex flex-col gap-20 lg:flex-row">
            <div>
              <h2 className="mb-10 text-center text-2xl font-bold tracking-tight">Platform Partners</h2>
              <div className="grid grid-cols-3 gap-10">
                {platformPartners.map((partner) => (
                  <a href={partner.website} target="_blank" key={partner.name} rel="noreferrer">
                    <Image src={partner.image} alt={partner.name} className="w-full" />
                  </a>
                ))}
              </div>
            </div>
            <div>
              <h2 className="mb-10 text-center text-2xl font-bold tracking-tight">Ventura Web Design Partners</h2>
              <div className="grid grid-cols-3 gap-10">
                {venturaWebDesignPartners.map((partner) => (
                  <Link
                    href={partner.website}
                    target={partner.name === "UPS" ? "_self" : "_blank"}
                    key={partner.name}
                  >
                    <Image src={partner.image} alt={partner.name} className="w-full" />
                  </Link>
                ))}
              </div>
            </div>
          </div>
          <div className="mt-20">
            <h2 className="mb-10 text-center text-2xl font-bold tracking-tight">Companies We Work With</h2>
            <div className="grid grid-cols-3 gap-10 lg:grid-cols-5 items-center">
              {companiesWeWorkWith.map((partner) => (
                <a href={partner.website} target="_blank" key={partner.name} rel="noreferrer">
                  <Image src={partner.image} alt={partner.name} className="w-full" />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
